import Vue from 'vue'
import axios from 'axios'
import Vueaxios from 'vue-axios'
import Con from '../../static/config.json'

Vue.use(Vueaxios, axios)
const URL = Con.URL
export default {
  getZone (obj, header, success, error) {
    Vue.axios.post(URL + 'homezone/search', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  addZone (obj, header, success, error) {
    Vue.axios.post(URL + 'homezone', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  editZone (obj, header, success, error) {
    Vue.axios.put(URL + 'homezone', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  deleteZone (id, header, success, error) {
    Vue.axios.delete(URL + 'homezone/' + id, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/services/service_zone.js